import './subscribesection.css'

const Subscribe = () => {
return(
    <div className="subscribemain" id='contact'>
    
    <div className="subsectionp">
    
    <div className="dubscribeheading">
    SUBSCRIBE FOR TO RECEIVE OUR UPDATES</div>


    <div className="subscribepadding">
    <p>Get the latest offers and discounts from Maniyar Bangles Online Shopping Website.</p>
    </div>
    
    <div className="subscribeemaisec">
    <input className="subbtn" type="text" placeholder='Enter Email Here' />
    <div className="subbtn2"><button>Subscribe</button></div>
    
    </div></div>
    
    
    
    </div>
);


}
export default Subscribe;